import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-enrollfrominvite',
  templateUrl: './enrollfrominvite.component.html',
  styleUrls: ['./enrollfrominvite.component.css']
})
export class EnrollfrominviteComponent implements OnInit {
  readonly userTokenLocalStorageKey = environment.userTokenStore;
  loadingstring: string;
  constructor(private activatedroute: ActivatedRoute, private useraccessservice: UseraccessserviceService,) { }

  async ngOnInit(): Promise<void> {
    const moduleId = this.activatedroute.snapshot.queryParamMap.get('module');
    const email = this.activatedroute.snapshot.queryParamMap.get('email');
    this.loadingstring = "Profile setup in progress ...";
    try {
      var payload: any = await this.useraccessservice.userRegistrationFromInviteMail(email, moduleId).toPromise();
      this.loadingstring = "logging you in ..."
      if (payload.token) {
        this.useraccessservice.setAuthenticatedUserToken(payload.token);
      }
      else {
        this.loadingstring = "Unable to log you in";
        return;
      }
      window.location.href = payload.url;
    }
    catch{
      this.loadingstring = "Registation failed";
    }
  }
  
}
